import Modal from "react-bootstrap/Modal";
import React from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import Delete from "../../assets/DeleteIcon.svg";
import Error from "../../assets/noErrorIcon.png";
import { useSelector } from "react-redux";
import { RotatingLines } from "react-loader-spinner";

const MyVerticallyCenteredModal = ({
  handleDisablefuc,
  handleDeletefuc,
  handleDeleteLocation,
  BtnLoading,
  page,
  ...props
}) => {

   const DeleteOrDisableFlag = useSelector((state) =>
    page === "voucher"
      ? state.DeleteFlag.deleteVoucherModelFlag
      : state.DeleteFlag.deleteCouponModelFlag
  );


  //   const DeleteLocation = (e) => {
  //   e.preventDefault();
  //   let flag = true;
  //   handleDeleteLocation(flag);
  // };

  const SaveHandler = (e) => {
    e.preventDefault();
    let flag = true;
    if (DeleteOrDisableFlag === false) {
      handleDeletefuc(flag);
    } else {
      handleDisablefuc(flag);
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="popup-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="text-center mb-5">
        <Image
            loading="lazy"
            src={DeleteOrDisableFlag === false ? Delete : Error}
            className="errorIconImage"
          />
          <p className="py-3 delete-text">
            {DeleteOrDisableFlag === false
              ? "Are you sure you want to delete?"
              : "You cannot delete the coupon as its already issued. Would you like to disable the coupon instead?"}
          </p>
        <div className="text-center small-btns d-flex">
          <Link onClick={props.onHide}>
            <p className="view">No</p>
          </Link>
          <Button
            variant="primary"
            className="green-btn"
            onClick={SaveHandler}
          >
            {BtnLoading === true ? (
              <RotatingLines strokeColor="white" width={20} visible={true} />
            ) : (
              "Yes"
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default MyVerticallyCenteredModal;
